module.exports = __webpack_public_path__ + "static/scale-model-of-sewell-park-in-hialeah-florida-e79e54ef9c46d02e4572276eac8de7bc.png";